export const Footer = () => {
  return (
    <footer className="container-fluid mt-5">
      <div className="container text-center p-3">
        © 2021 - {new Date().getFullYear()} Copyright: Vesna Grujanić
      </div>
    </footer>
  );
};
